const axios = require('axios')

const prizeSpinUrl = process.env.REACT_APP_HOST_API + '/prize-spin'

export const checkPrizeEligibility = async (userId, sessionId) => {
  try {
    const res = await axios.get(`${prizeSpinUrl}/check/${userId}/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error checking prize eligibility:', error)
    throw error
  }
}

export const savePrizeSpin = async (userId, sessionId, prize, email) => {
  try {
    const res = await axios.post(`${prizeSpinUrl}/spin`, {
      userId,
      sessionId,
      prize,
      email: email || null
    })
    return res.data
  } catch (error) {
    console.error('Error saving prize spin:', error)
    throw error
  }
}

export const getPrizeSpinsBySession = async (sessionId) => {
  try {
    const res = await axios.get(`${prizeSpinUrl}/session/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error fetching prize spins:', error)
    throw error
  }
}